import * as S from "./styled";

function HeaderAnimation() {
  return <S.HeaderAnimation />;
}

export default HeaderAnimation;
